import script from "./CargarPadron.vue?vue&type=script&setup=true&lang=js"
export * from "./CargarPadron.vue?vue&type=script&setup=true&lang=js"

import "./CargarPadron.vue?vue&type=style&index=0&id=398db85e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-398db85e"]])

export default __exports__